import React from 'react';

const TwoColumnYesNoField = ({ question, ids = [], fieldValues = {}, onChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-[3fr_1fr_1fr] border-t border-[var(--blue-2)] py-4 items-center">
      <div className="text-[var(--slate-grey-2)] text-sm font-medium pr-4">{question}</div>
      {ids.map((id) => (
        <div key={id} className="flex gap-4 items-center justify-start">
          <label className="checkbox-label">
            <input
              type="checkbox"
              className="checkbox-accent"
              id={`field-${id}-yes`}
              name={`field-${id}`}
              checked={fieldValues[id] === true}
              onChange={() => onChange(id, true)}
            />
            Yes
          </label>
          <label className="checkbox-label">
            <input
              type="checkbox"
              className="checkbox-accent"
              id={`field-${id}-no`}
              name={`field-${id}`}
              checked={fieldValues[id] === false}
              onChange={() => onChange(id, false)}
            />
            No
          </label>
        </div>
      ))}
    </div>
  );
};

export default TwoColumnYesNoField;
